import React from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';

function Card({ service }) {

	const location_origin = typeof window !== "undefined" ? `${window.location.origin.toString()}/` : `https://www.notaio-treviso.com/`

	return (
		<div className="boxServizi">
			<div className='mediaStyle'>

				<h1 className='servizio_nome'>{service.name}</h1>

				{(() => {
					// i = 5 perchè sono 4 le categorie finora utilizzate
					for (var i = 1; i < 5; i++) {
						if (service.codice_tipo == i) {
							return (<h2 className={'servizio_tipo_' + i + ' servizioBox'}>{service.tipologia}</h2>)
						}
					}
				})()}
				<a title={`${service.name} atto notarile a Treviso`} href={`${location_origin}servizi/${service.link}`}><img title={'notaio a Treviso - ' + service.name} className='imgBox' alt={'notaio a Treviso - ' + service.name} src={service.imageArt}></img></a>

				<h3 className='servizio_link'><a title={`${service.name} | Notaio a Treviso`} className='approfondisci' href={`${location_origin}servizi/${service.link}`}>
					{service.description.substring(0, 200)}...</a></h3>

				<div className='boxButtonInfo'>
					<MDBBtn outline className='m-1 pl-2 pr-2 p-0 text-wrap text-center'color='dark' title={`${service.name} informazioni | Notaio a Treviso`} href={`${location_origin}servizi/${service.link}/informazioni`}>Richiedi info</MDBBtn>
					<MDBBtn outline className='m-1 pl-2 pr-2 p-0 text-wrap text-center'color='dark' title={`${service.name} preventivo | Notaio a Treviso`}href={`${location_origin}servizi/${service.link}/preventivo`}>Richiedi preventivo</MDBBtn>
					<MDBBtn outline className='m-1 pl-2 pr-2 p-0 text-wrap text-center'color='dark' title={`${service.name} | Notaio a Treviso`} href={`${location_origin}servizi/${service.link}`}>Scopri di più</MDBBtn>
				</div>
			</div>
		</div>
	);
}

export default Card;